import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA6c_dG-Ti5U7c3IkqTgFzzz2x17bc0WI4",
  authDomain: "bootcamp-7bfa4.firebaseapp.com",
  databaseURL: "https://bootcamp-7bfa4-default-rtdb.firebaseio.com",
  projectId: "bootcamp-7bfa4",
  storageBucket: "bootcamp-7bfa4.appspot.com",
  messagingSenderId: "486354947548",
  appId: "1:486354947548:web:c4f305bc2c5ea40b9dd319",
  measurementId: "G-WQMHMVKB4Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const storage = getStorage(app);
export default app
